/**
 * The skill map a scenario costs with, opened on the scenario's regime (FIQ-2457). The
 * regime only preselects what the Schedule assignments view browses; assignments still
 * belong to the skill map.
 *
 * @param {{ skillMapId: string, regimeId?: string }} scenario
 * @returns {string}
 */
export function scenarioSkillMapPath({ skillMapId, regimeId }) {
    const path = `/app/optimiser/skill-mappings/${skillMapId}`
    if (!regimeId) return path
    return `${path}?${new URLSearchParams({ assignmentRegime: regimeId })}`
}
